/* eslint-disable no-case-declarations */
// import GQL from '@trurisk/core/graphql/gqlschema';
import { uniqBy } from 'lodash';
import { SET_CHIPS, UPDATE_THE_CHIPS } from './types';
// const initialState: IChips = { sector: {}, product: {}, model: {}, mapped_controls: [] } as IChips;
const initialState = {
    mapped_controls: [],
    master_risk_category: [],
    insurance_product: [],
    sector: [],
    account: [],
    service_role: [],
    assignee: [],
    location: [],
};
// eslint-disable-next-line import/prefer-default-export
export function chipsReducer(state = initialState, action) {
    // console.log('action type = ', action.type);
    // console.log('action = ', action);
    // console.log('state = ', state);
    switch (action.type) {
        case SET_CHIPS:
            return Object.assign(Object.assign({}, state), action.payload);
        case UPDATE_THE_CHIPS:
            const addState = Object.assign({}, state);
            // addState[action.field] = action.payload;
            // addState['mapped_controls'] = action.payload;
            // addState.mapped_controls = action.payload;
            if ((action === null || action === void 0 ? void 0 : action.field) === 'mapped_controls') {
                addState.mapped_controls = action.payload;
            }
            else if ((action === null || action === void 0 ? void 0 : action.field) === 'master_risk_category') {
                addState.master_risk_category = action.payload;
            }
            else if ((action === null || action === void 0 ? void 0 : action.field) === 'insurance_product') {
                addState.insurance_product = action.payload;
            }
            else if ((action === null || action === void 0 ? void 0 : action.field) === 'sector') {
                addState.sector = uniqBy([...state.sector, ...action.payload], 'id');
            }
            else if ((action === null || action === void 0 ? void 0 : action.field) === 'account') {
                addState.account = action.payload;
            }
            else if ((action === null || action === void 0 ? void 0 : action.field) === 'service_role') {
                addState.service_role = uniqBy(action.payload, 'role_id');
            }
            else if ((action === null || action === void 0 ? void 0 : action.field) === 'assignee') {
                addState.assignee = uniqBy([...state.assignee, ...action.payload], 'id');
            }
            else if ((action === null || action === void 0 ? void 0 : action.field) === 'location') {
                addState.location = uniqBy([...state.location, ...action.payload], 'id');
            }
            // addState[`${action?.field}`] = action.payload;
            return addState;
        default:
            return state;
    }
}
